/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class VideoObjectsApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of video object details. If objects belong to a stream they are not listed.
     */
    async videosGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.sortByTime !== undefined) {
            queryParameters['sortByTime'] = requestParameters.sortByTime;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.owner !== undefined) {
            queryParameters['owner'] = requestParameters.owner;
        }
        if (requestParameters.prefix !== undefined) {
            queryParameters['prefix'] = requestParameters.prefix;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of video object details. If objects belong to a stream they are not listed.
     */
    async videosGet(requestParameters = {}, initOverrides) {
        const response = await this.videosGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new video object.
     */
    async videosPostRaw(requestParameters, initOverrides) {
        if (requestParameters.videoObjectInsert === null ||
            requestParameters.videoObjectInsert === undefined) {
            throw new runtime.RequiredError('videoObjectInsert', 'Required parameter requestParameters.videoObjectInsert was null or undefined when calling videosPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.videoObjectInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new video object.
     */
    async videosPost(requestParameters, initOverrides) {
        const response = await this.videosPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a video blob.
     */
    async videosVideoIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdDelete.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a video blob.
     */
    async videosVideoIdBlobsBlobIdDelete(requestParameters, initOverrides) {
        await this.videosVideoIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a video blob.
     */
    async videosVideoIdBlobsBlobIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdGet.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a video blob.
     */
    async videosVideoIdBlobsBlobIdGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsBlobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a video blob media info.
     */
    async videosVideoIdBlobsBlobIdMediaInfoGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdMediaInfoGet.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdMediaInfoGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}/mediaInfo`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a video blob media info.
     */
    async videosVideoIdBlobsBlobIdMediaInfoGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsBlobIdMediaInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a video blob media info.
     */
    async videosVideoIdBlobsBlobIdMediaInfoPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdMediaInfoPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdMediaInfoPatch.');
        }
        if (requestParameters.aVMediaInfo === null ||
            requestParameters.aVMediaInfo === undefined) {
            throw new runtime.RequiredError('aVMediaInfo', 'Required parameter requestParameters.aVMediaInfo was null or undefined when calling videosVideoIdBlobsBlobIdMediaInfoPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}/mediaInfo`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.aVMediaInfo,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a video blob media info.
     */
    async videosVideoIdBlobsBlobIdMediaInfoPatch(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsBlobIdMediaInfoPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a video blob.
     */
    async videosVideoIdBlobsBlobIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdPatch.');
        }
        if (requestParameters.videoBlobEdit === null ||
            requestParameters.videoBlobEdit === undefined) {
            throw new runtime.RequiredError('videoBlobEdit', 'Required parameter requestParameters.videoBlobEdit was null or undefined when calling videosVideoIdBlobsBlobIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.videoBlobEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a video blob.
     */
    async videosVideoIdBlobsBlobIdPatch(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsBlobIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrigger analysis of a video blob.
     */
    async videosVideoIdBlobsBlobIdReanalyzePostRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdReanalyzePost.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdReanalyzePost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}/reanalyze`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Retrigger analysis of a video blob.
     */
    async videosVideoIdBlobsBlobIdReanalyzePost(requestParameters, initOverrides) {
        await this.videosVideoIdBlobsBlobIdReanalyzePostRaw(requestParameters, initOverrides);
    }
    /**
     * Edit a video blob status (media info and alerts).
     */
    async videosVideoIdBlobsBlobIdStatusPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsBlobIdStatusPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling videosVideoIdBlobsBlobIdStatusPatch.');
        }
        if (requestParameters.aVMediaInfoContentBlobStatus === null ||
            requestParameters.aVMediaInfoContentBlobStatus === undefined) {
            throw new runtime.RequiredError('aVMediaInfoContentBlobStatus', 'Required parameter requestParameters.aVMediaInfoContentBlobStatus was null or undefined when calling videosVideoIdBlobsBlobIdStatusPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs/{blobId}/status`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.aVMediaInfoContentBlobStatus,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a video blob status (media info and alerts).
     */
    async videosVideoIdBlobsBlobIdStatusPatch(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsBlobIdStatusPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of blobs of a video object.
     */
    async videosVideoIdBlobsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsGet.');
        }
        const queryParameters = {};
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of blobs of a video object.
     */
    async videosVideoIdBlobsGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new video blob.
     */
    async videosVideoIdBlobsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdBlobsPost.');
        }
        if (requestParameters.videoBlobInsert === null ||
            requestParameters.videoBlobInsert === undefined) {
            throw new runtime.RequiredError('videoBlobInsert', 'Required parameter requestParameters.videoBlobInsert was null or undefined when calling videosVideoIdBlobsPost.');
        }
        const queryParameters = {};
        if (requestParameters.customId !== undefined) {
            queryParameters['customId'] = requestParameters.customId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/blobs`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.videoBlobInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new video blob.
     */
    async videosVideoIdBlobsPost(requestParameters, initOverrides) {
        const response = await this.videosVideoIdBlobsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an video object.
     */
    async videosVideoIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an video object.
     */
    async videosVideoIdDelete(requestParameters, initOverrides) {
        await this.videosVideoIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get video object details.
     */
    async videosVideoIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get video object details.
     */
    async videosVideoIdGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit video object details.
     */
    async videosVideoIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdPatch.');
        }
        if (requestParameters.videoObjectEdit === null ||
            requestParameters.videoObjectEdit === undefined) {
            throw new runtime.RequiredError('videoObjectEdit', 'Required parameter requestParameters.videoObjectEdit was null or undefined when calling videosVideoIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.videoObjectEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit video object details.
     */
    async videosVideoIdPatch(requestParameters, initOverrides) {
        const response = await this.videosVideoIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of video uploads.
     */
    async videosVideoIdUploadsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdUploadsGet.');
        }
        const queryParameters = {};
        if (requestParameters.blobId !== undefined) {
            queryParameters['blobId'] = requestParameters.blobId;
        }
        if (requestParameters.includeClosed !== undefined) {
            queryParameters['includeClosed'] = requestParameters.includeClosed;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/uploads`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of video uploads.
     */
    async videosVideoIdUploadsGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdUploadsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new video upload.
     */
    async videosVideoIdUploadsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdUploadsPost.');
        }
        if (requestParameters.videoUploadInsert === null ||
            requestParameters.videoUploadInsert === undefined) {
            throw new runtime.RequiredError('videoUploadInsert', 'Required parameter requestParameters.videoUploadInsert was null or undefined when calling videosVideoIdUploadsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/uploads`.replace(`{${'videoId'}}`, String(requestParameters.videoId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.videoUploadInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new video upload.
     */
    async videosVideoIdUploadsPost(requestParameters, initOverrides) {
        const response = await this.videosVideoIdUploadsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a video upload.
     */
    async videosVideoIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdUploadsUploadIdDelete.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling videosVideoIdUploadsUploadIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/uploads/{uploadId}`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a video upload.
     */
    async videosVideoIdUploadsUploadIdDelete(requestParameters, initOverrides) {
        await this.videosVideoIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a video upload.
     */
    async videosVideoIdUploadsUploadIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.videoId === null ||
            requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId', 'Required parameter requestParameters.videoId was null or undefined when calling videosVideoIdUploadsUploadIdGet.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling videosVideoIdUploadsUploadIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/videos/{videoId}/uploads/{uploadId}`
                .replace(`{${'videoId'}}`, String(requestParameters.videoId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a video upload.
     */
    async videosVideoIdUploadsUploadIdGet(requestParameters, initOverrides) {
        const response = await this.videosVideoIdUploadsUploadIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const VideosGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const VideosGetSortByTimeEnum = {
    Desc: 'Desc',
    Asc: 'Asc',
};
/**
 * @export
 */
export const VideosVideoIdBlobsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=VideoObjectsApi.js.map